import { render, staticRenderFns } from "./SingleChoiceExam.vue?vue&type=template&id=8fcd3274&scoped=true&"
import script from "./SingleChoiceExam.vue?vue&type=script&lang=js&"
export * from "./SingleChoiceExam.vue?vue&type=script&lang=js&"
import style0 from "./SingleChoiceExam.vue?vue&type=style&index=0&id=8fcd3274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcd3274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VAlert,VBtn,VDivider,VExpandTransition,VIcon,VOverlay,VRadio,VRadioGroup})
